import { defineComponent, inject, ref } from "vue";
import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import { orderServiceKey } from "../../../infrastructure/gfo_api/order_service";
import { ApiValidationError } from "../../../infrastructure/gfo_api/api_validation_error";
import ErrorMessage from "../../Shared/ErrorMessage";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default defineComponent({
  template: html,
  components: { ErrorMessage },
  setup() {
    // Injections
    const { t } = useI18n();
    const orderService = inject(orderServiceKey);

    // vars und computed
    const generalError = ref("");
    // Fehler pro Feld, keyed wie das Request-Objekt (snake_case, wie vom Server zurückgemeldet)
    // ein Feld kann mehrere Fehlermeldungen haben
    const errors = ref<Record<string, string[]>>({});

    const voucherCode = ref<string | null>(null);

    // methods
    const save = async () => {
      errors.value = {};
      generalError.value = "";
      if (orderService == null) {
        return;
      }
      try {
        await orderService.addVoucher(voucherCode.value);
        voucherCode.value = null;
      } catch (err) {
        if (err instanceof ApiValidationError) {
          errors.value = { ...err.errors };
          generalError.value = err.title;
        } else {
          generalError.value = `${err}`;
        }
      }
    };

    return {
      t,
      generalError,
      errors,
      voucherCode,
      save,
    };
  },
} as any);
